/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import { handleGetData } from '../../Api';
import { Loading } from '../../components/Loading';
import { Capa } from '../../components/Capa';
import * as S from './style';

export const WorkWithUs = () => {
  const [data, setData] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/trabalheconosco/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A página tem a própria capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <div style={{ position: 'relative' }}>
        <Capa
          imagem={[data?.banner?.iv?.imagemBackground?.[0], data?.imagemHeader?.iv?.[0]]}
          selo={data?.banner?.iv?.titulo}
          titulo={data?.titulo?.iv}
          texto={data?.banner?.iv?.subtitulo}
        >
          {data?.banner?.iv?.botaoLink?.tituloLink && (
            <S.NavLinkCustom
              to={data?.banner?.iv?.botaoLink?.linkExterno}
              target="_blank"
            >
              {data?.banner?.iv?.botaoLink?.tituloLink}
            </S.NavLinkCustom>
          )}
          {data?.banner?.iv?.botaoSecundario?.tituloLink && (
            <S.NavLinkCustom
              to={data?.banner?.iv?.botaoSecundario?.linkExterno}
              target="_blank"
            >
              {data?.banner?.iv?.botaoSecundario?.tituloLink}
            </S.NavLinkCustom>
          )}
        </Capa>
      </div>
    );
  }
};
